/*
 * Copyright © 2026 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

import React, { ReactElement } from "react"
import { observer } from "mobx-react-lite"
import { useHeartReportStores } from "../heart-report-context"
import { HeartReportCard, SupportLink } from "../components/heart-report-layout"
import heartReportCopy from "../heartReportCopy"

const copy = heartReportCopy.unavailable

/** The link can't be used: one screen, copy picked by the reason the store recorded. */
const Unavailable = observer((): ReactElement => {
  const { sessionStore } = useHeartReportStores()
  const reasonCopy = copy[sessionStore.unavailableReason ?? "expired"]

  return (
    <HeartReportCard title={reasonCopy.title}>
      <p className="mt-2 text-center text-gray-600">{reasonCopy.body}</p>
      <p className="mt-6 text-center text-sm text-gray-500">
        <SupportLink>{copy.contactSupport}</SupportLink>
      </p>
    </HeartReportCard>
  )
})

export default Unavailable
